// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Slugs_x0gITr_a_QEU15NP8NMb{display:flex;flex-wrap:wrap;gap:.5em;align-items:center}`, "",{"version":3,"sources":["webpack://./src/components/slugs/Slugs/Slugs.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,cAAA,CACA,QAAA,CACA,kBAAA","sourcesContent":[".Slugs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5em;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Slugs": `Slugs_x0gITr_a_QEU15NP8NMb`
};
export default ___CSS_LOADER_EXPORT___;
